import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Charger = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: [_jsx("path", { d: "M2.5 8.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v5A6.25 6.25 0 0 1 11.25 20h-2.5a6.25 6.25 0 0 1-6.25-6.25z" }), _jsx("path", { fillRule: "evenodd", d: "M6.25 0C6.94 0 7.5.56 7.5 1.25V7.5H5V1.25C5 .56 5.56 0 6.25 0m7.5 0C14.44 0 15 .56 15 1.25V7.5h-2.5V1.25c0-.69.56-1.25 1.25-1.25" })] }));
});
Charger.displayName = 'Charger';
Charger.__iconComponentType = 'standard';
export default Charger;
//# sourceMappingURL=Charger.js.map